module.exports = __webpack_public_path__ + "img/svg/logo-icon.aa00d0949a3f2c7377434e90d148b381.svg";